import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useOutletContext } from 'react-router-dom';
import { useAuth } from "../../../context/auth-context";
import { rootUrl } from "../../../helpers";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { FaEye, FaMoneyBill, FaTimes } from "react-icons/fa";
import { FaFileLines } from "react-icons/fa6";
import AddBillModal from "../bills/addBill";
import CustomerData from "./customerStatement";


const CustomerPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [title, setTitle] = useState('');
  const [output, setOutput] = useState('');
  const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [formData, setFormData] = useState({
    code: "",
    account_no: "",
    firstname: "",
    middlename: "",
    lastname: "",
    phonenumber: "",
    sex: "",
    nrc: "",
    dob: "",
  });


  const allData = useOutletContext();
  const auth = useAuth();

  useEffect(() => {
    fetchCustomers();
  }, []);


  

  const fetchCustomers = async () => {
    try {
      const response = await axios.get(rootUrl(`/getCustomers/${auth.user.id}`));
      setCustomers(response.data.data);

      
    
    } catch (error) {
      toast.error("Error fetching bills:", error);
    }


  };




  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    formData['uid'] = auth.user.id
    try{

      const response = await axios.post(rootUrl("/addCustomer"), formData)
      console.log(response)
      if(response.data.status === 200){
        toast.success("Submitted successfully")
        setShowModal(false)


        setFormData(
          {
            code: "",
            account_no: "",
            firstname: "",
            middlename: "",
            lastname: "",
            phonenumber: "",
            sex: "",
            nrc: "",
            dob: "",
          }
        )

      }else{
        toast.info(response.data.msg)
      }

    }catch(e){
      toast.error(e?.message)
    }

  };

  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };

  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };


  const columns = [
    {
      name: "Sn",
      selector: (row, index) => index + 1,
      width: "50px",
      center: true,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Account No",
      selector: (row) => row.account_no,
      sortable: true,
    },
    {
      name: "Names",
      selector: (row) =>
        `${row.firstname} ${row.middlename ? row.middlename : ""} ${row.lastname}`,
      sortable: true,
    },
    {
      name: "Contact",
      selector: (row) => row.phonenumber,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
                {/* <button onClick={()=>addPay(row.id, 1)} className="text-blue-500 underline m-2 text-lg"> <FaMoneyBill/> </button> */}
                <button onClick={()=>addPay(row.id, 2)} className="text-blue-500 underline m-2 text-lg"> <FaFileLines/> </button>
                {/* <button onClick={openSlidingDiv} className="text-blue-500 underline m-2 text-lg"> <FaEye/> </button> */}
        </>
        
      ),
      button: true,
      center: true,
    },
  ];

  const addPay = (id, type) =>{
    if(type === 1){

        setTitle("Add payment")
        setOutput(<AddBillModal data={allData} onSubmit={onSubmit} />)
    }else{

        setTitle("Customer Statement")
        setOutput(<CustomerData id={id} />)
    }
    openSlidingDiv()

  }

  const onSubmit = async (payload)=>{

        payload['uid'] = auth.user.id
        try{
            const response = await axios.post(rootUrl('/addBillAndPayment'), payload)
            if(response.data.status === 200){
                toast.success("Submitted successfully")
                setShowSlidingDiv(false)
            }else{
                toast.error("Something went wrong")
            }
      
        }catch(e){
            toast.error(e?.message)
        }
    
      

  }

  const filteredData = customers.filter(customer =>
    customer.firstname.toLowerCase().includes(searchQuery.toLowerCase()) ||
    customer.lastname.toLowerCase().includes(searchQuery.toLowerCase())
);

  return (
    <div className="w-full bg-white min-h-[400px] rounded-md mt-10 p-5">
      {/* Header */}
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="text-[25px] text-slate-800 font-bold">Customers</h1>
          <span className="text-[12px] text-slate-700">All customer Info</span>
        </div>

        <div className="flex items-center">
        <button
          onClick={toggleModal}
          className="flex btn bg-blue-900  text-white items-center justify-center border border-gray-300 h-[40px] px-3 ml-2 rounded-md text-[12px]"
        >
          <i className="fa fa-plus mr-2" aria-hidden="true"></i>
          New Customer
        </button>

        <button 
           className="flex btn bg-blue-900 text-white items-center justify-center border border-gray-300 h-[40px] px-3 ml-2 rounded-md text-[12px]"
        onClick={()=>addPay(1, 1)}>Add Payment</button>
   </div>
     
      </div>
      <hr />

      {/* Customer Table */}
      <div id="allCust">

      <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)} // Update search query state
                className="mb-4 p-2 border border-gray-300 rounded"
            />
     
      <DataTable
                title=""
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                striped
                responsive
            />

      </div>

      {/* Sliding Div */}
      {showSlidingDiv && (
        <div
          id="slidingDiv"
          className="bg-white fixed top-0 right-0 h-full w-1/2 overflow-hidden shadow-lg"
        >
            <FaTimes 
                onClick={closeSlidingDiv}
                className="p-1 m-1 text-2xl text-red-500 float-right cursor-pointer"
            />
          
          <h3 className="m-2 font-semibold text-lg">{title}</h3>
          <hr />
          <div id="form">{output}</div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <form
            onSubmit={handleSubmit}
            className="bg-white min-h-[60vh] rounded p-5 w-[60%] mx-20 shadow-lg overflow-y-auto relative"
          >
            <div className="flex justify-between items-center mb-4 border-b pb-5">
              <h2 className="text-xl font-semibold">Add New Customer</h2>
              <button
                type="button"
                onClick={toggleModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fa fa-times"></i>
              </button>

              
            </div>

            <div className="p-4 w-full grid grid-cols-2 gap-4">
              {/* Form Fields */}
              {Object.keys(formData).map((key) => (
                <div className="w-full" key={key}>
                  <label htmlFor={key} className="text-[12px] mb-3 capitalize">
                    {key.replace("_", " ")}
                  </label>
                  {
  key === 'sex' ? (
    <select
      id={key}
      value={formData[key]}
      onChange={handleInputChange}
      className="border rounded p-2 w-full text-[12px]"
      required
    >
      <option value="">Select sex</option>
      <option value="male">Male</option>
      <option value="female">Female</option>
    </select>
  ) : (
    <input
      id={key}
      value={formData[key]}
      onChange={handleInputChange}
      placeholder={key.replace("_", " ")}
      className="border rounded p-2 w-full text-[12px]"
      type={key==='dob'?'date':'text'}
      required={["code", "account_no", "firstname", "phonenumber","sex"].includes(key)}
    />
  )
}
                </div>
              ))}
            </div>

            <div className="mt-4 flex justify-end mt-10 pt-5 border-t col-span-2">
              <button
                type="button"
                onClick={toggleModal}
                className="bg-gray-100 hover:bg-gray-200 w-[150px] text-[13px] text-gray-700 font-semibold py-2 px-4 rounded"
              >
                Close
              </button>
              <button
                type="submit"
                className="bg-blue-900 hover:bg-blue-900/90 w-[150px] text-[13px] text-white font-bold py-2 px-4 rounded mx-2"
              >
                <i className="fa fa-paper-plane mr-2"></i>
                <span>Submit</span>
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CustomerPage;
